import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { useAppSelector } from '@/store/hooks';
import styles from './GlobalLoader.module.scss';

export function GlobalLoader() {
  const loadingCount = useAppSelector((state) => state.ui.globalLoadingCount);
  const visible = loadingCount > 0;

  if (!visible) return null;

  return (
    <div className={styles.overlay} role="status" aria-live="polite" aria-label="Loading">
      <div className={styles.panel}>
        <Spin indicator={<LoadingOutlined className={styles.spinner} spin />} size="large" />
        <span className={styles.label}>Loading…</span>
      </div>
    </div>
  );
}
